import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ValidatorUtils } from '../../utils';

import logo from '../../assets/logo-icon.png';
import '../../css/InstantScreens/Instant.css';

import { Routes as routes, History as history } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, InstantActions, ToastActions } from '../../actions';
import { TitleBar, NavBar, Input, Button, Line } from  '../../components'

class InstantLandingScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      loading: false,
      validation: {},
    }
  }

  componentDidMount() {

  }

  render() {
    return (
      <div className="flex-container flex-container-column" style={{  justifyContent: 'center', alignItems: 'center' }}>
        <div className='flex-container-column' style={{ marginTop: 60, paddingBottom: 10, paddingRight: 10, alignItems: 'flex-end', width: 400 }}>
          <div className='instant-join-session-button'
               onClick={ () => {
                 const screen_props = {
                   is_no_nav: true
                 }
                 history.push({ pathname: routes.INSTANT_HELP, state: { props: screen_props } })
               }}>
            <span className='fas fa-info-circle' style={{ fontSize: 16, marginRight: 8 }}/>
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>FAQs</span>
          </div>
        </div>
        <div className='instant-sign-in-container flex-container-column' style={{ marginTop: 0 }}>
          <div className='flex-container-column' style={{ flex: 1, justifyContent: 'center' }}>
            <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 15 }}>
              <img className="instant-sign-in-logo-image" src={logo} alt="Icon Text" />
              <span style={{ fontWeight: 'bold', fontSize: 22, marginTop: 0 }}>TeleTails</span>
              <span style={{ fontWeight: '600', fontSize: 12, marginTop: -5, color: '#1dc2ff' }}>INSTANT</span>
            </div>
            <div className='flex-container-column' style={{ marginTop: 15, alignItems: 'center' }}>
              <Input placeholder="Email"
                     value={this.state.email}
                     className='instant-input-default'
                     invalid={this.state.validation.fields && this.state.validation.fields['email']}
                     style={{ }}
                     onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
                    />
              <Input placeholder="Password"
                     value={this.state.password}
                     className='instant-input-default'
                     invalid={this.state.validation.fields && this.state.validation.fields['password']}
                     style={{ marginTop: 5 }}
                     onChange={ (event) => { this.setState({ ...this.state, password: event.target.value }) }}
                     type="password"
                    />
              <Button value='Sign In'
                      style={{ marginTop: 10, paddingLeft: 50, paddingRight: 50 }}
                      loading={this.state.loading}
                      onClick={ () => {
                        this.processSignIn();
                      }}/>
            </div>
          </div>


          <Line />
          <div className='flex-container-row' style={{ alignItems: 'center', flex: 0.2, justifyContent: 'center' }}>
            <div className='flex-container-row' style={{ flex: 1, justifyContent: 'center' }}>
              <Button value='Create Account'
                      className='button-clear-blue'
                      onClick={ () => {
                        history.push(routes.INSTANT_SIGN_UP);
                      }}/>
            </div>
            <div style={{ height: 25, width: 1, backgroundColor: '#e7e7e7', marginRight: 8, marginLeft: 8 }}></div>
            <div className='flex-container-row' style={{ flex: 1, justifyContent: 'center' }}>
              <Button value='Forgot Password'
                      className='button-clear-blue'
                      onClick={ () => {
                        NavigationActions.navigateTo(routes.USER_FORGOT_PASSWORD);
                      }}/>
            </div>
          </div>
        </div>
      </div>
    );
  }

  processSignIn = () => {

    let sign_in_data = {
      email: this.state.email,
      password: this.state.password,
    }

    let validation    = ValidatorUtils.validate('instantSignIn', sign_in_data);

    if (!validation.valid) {
      let errors_arr = validation.errors || [];
      let error      = errors_arr.length > 0 ? errors_arr[0] : '';
      if (error) {
        this.props.toastActions.displayError(error);
      }
      this.setState({ ...this.state, validation: validation, loading: false });
      return;
    } else {
      this.setState({ ...this.state, validation: validation, loading: true });
    }

    this.props.instantActions.instantLogin(this.state.email, this.state.password, '', this.callback);
    this.setState({ ...this.state, loading: true });

  }

  callback = () => {
    this.setState({ ...this.state, loading: false });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    instant: state.instant,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    instantActions: bindActionCreators(
     { ...InstantActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstantLandingScreen)
